import AppModule from './AppModule'

export default AppModule
